"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var ORIGINAL_STYLE_COLOR_SELECTOR = "[data-" + "ogsc" /* OriginalStyleColor */ + "],[data-" + "ogac" /* OriginalAttributeColor */ + "]";
var ORIGINAL_STYLE_BACK_COLOR_SELECTOR = "[data-" + "ogsb" /* OriginalStyleBackgroundColor */ + "],[data-" + "ogab" /* OriginalAttributeBackgroundColor */ + "]";
/**
 * @internal
 * Get style based format state from current selection, including font name/size and colors
 * @param core The EditorCore objects
 * @param node The node to get style from
 */
exports.getStyleBasedFormatState = function (core, node) {
    if (!node) {
        return {};
    }
    var styles = node ? roosterjs_editor_dom_1.getComputedStyles(node) : [];
    var isDarkMode = core.lifecycle.isDarkMode;
    var root = core.contentDiv;
    var ogTextColorNode = isDarkMode && roosterjs_editor_dom_1.findClosestElementAncestor(node, root, ORIGINAL_STYLE_COLOR_SELECTOR);
    var ogBackgroundColorNode = isDarkMode && roosterjs_editor_dom_1.findClosestElementAncestor(node, root, ORIGINAL_STYLE_BACK_COLOR_SELECTOR);
    return {
        fontName: styles[0],
        fontSize: styles[1],
        textColor: styles[2],
        backgroundColor: styles[3],
        textColors: ogTextColorNode
            ? {
                darkModeColor: styles[2],
                lightModeColor: ogTextColorNode.dataset["ogsc" /* OriginalStyleColor */] ||
                    ogTextColorNode.dataset["ogac" /* OriginalAttributeColor */],
            }
            : undefined,
        backgroundColors: ogBackgroundColorNode
            ? {
                darkModeColor: styles[3],
                lightModeColor: ogBackgroundColorNode.dataset["ogsb" /* OriginalStyleBackgroundColor */] ||
                    ogBackgroundColorNode.dataset["ogab" /* OriginalAttributeBackgroundColor */],
            }
            : undefined,
    };
};
//# sourceMappingURL=getStyleBasedFormatState.js.map